import api from '@/apis'

export const fetchList = params => api.get(`/users`, { params })
export const setActiveState = (id, isActive) => api.put(`/users/${id}/set_active`, { isActive })
